import React from 'react'

export const ImageServiceContext = React.createContext()

export const ImageServiceContextProvider = ({ imagesUrl, children }) => {
  if (!imagesUrl) {
    throw new Error('imagesUrl must be set')
  }
  const imageURL = ({
    checksum,
    region = 'full',
    size = 'max',
    rotation = '0',
    quality = 'default',
    format = 'png',
  }) => {
    const iiif = `${region}/${size}/${rotation}/${quality}.${format}`
    if (!checksum) {
      return ''
    }
    return `${imagesUrl}?checksum=${encodeURIComponent(checksum)}&iiif=${encodeURIComponent(iiif)}`
  }
  return <ImageServiceContext.Provider value={{ imageURL }}>{children}</ImageServiceContext.Provider>
}
